import { ComponentType, FC, ReactNode } from "react";
import { Button } from "@design-system/Button/Button";
import {
    PendingOrgBillingTransferModalProps,
    usePendingOrgBillingTransferModal,
} from "./usePendingOrgBillingTransferModal";

interface PendingOrgBillingTransferModalButtonProps {
    modal: ComponentType<PendingOrgBillingTransferModalProps>;
    variant: "primary" | "secondary";
    children: ReactNode;
}

export const PendingOrgBillingTransferModalButton: FC<
    PendingOrgBillingTransferModalButtonProps
> = ({ modal: Modal, variant, children }) => {
    const { request, openModal, modal } =
        usePendingOrgBillingTransferModal(Modal);

    if (!request) {
        return null;
    }

    return (
        <>
            <Button variant={variant} size="md" onClick={openModal}>
                {children}
            </Button>
            {modal}
        </>
    );
};
